import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigResourceService } from './config-resource.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ConfigResourceService],
})
export class ConfigResourceModule { }
